import { render } from "./Animation.vue?vue&type=template&id=19f1fe60"
const script = {}

import "./Animation.vue?vue&type=style&index=0&id=19f1fe60&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__